/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable security/detect-object-injection */
/* eslint-disable import/no-unresolved */
import { Button, TextField } from "@mui/material";
import { memo, useCallback, useState } from "react";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CustomBoxModal from "src/shared/CustomModalBox";
import UploadDocument from "src/shared/UploadDocument";
import { OPTIONS } from "src/helpers/Dashboard/resources";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { UseMutateFunction } from "react-query";

interface Props {
  uploadMutation: UseMutateFunction<any, unknown, any, unknown>;
}

function CustomerDeclarationDataEntry({ uploadMutation }: Props) {
  const leadId = useAppSelector((state) => state.common.leadId);

  const [showSignatureUploadForm, setShowSignatureUploadForm] = useState(false);
  const [mefFile, setMEFFile] = useState<File | null>(null);
  const [uploadedFileName, setUploadedFileName] = useState("");

  const handleSignatureIconClick = () => {
    setShowSignatureUploadForm(true);
  };

  const handleModalClick = useCallback(() => {
    setShowSignatureUploadForm(false);
    setUploadedFileName("");
    setMEFFile(null);
  }, []);

  const handleSaveFile = useCallback(() => {
    setUploadedFileName(mefFile!.name);
    setShowSignatureUploadForm(false);
  }, [mefFile]);

  return (
    <>
      {showSignatureUploadForm && (
        <CustomBoxModal onClose={handleModalClick}>
          <div className="pb-4 md:px-4">
            <UploadDocument
              className="w-64 md:w-96"
              title="Upload MEF"
              description={mefFile?.name || "Click/Drag & Drop to upload"}
              supportedFileText="PDF"
              setFile={setMEFFile}
              acceptedFiles={[".pdf"]}
            />
            <div className="text-center px-4 mt-2">
              <Button
                disabled={
                  !mefFile ||
                  !OPTIONS?.signatureExtensionSupported.includes(
                    `.${mefFile?.name.split(".").pop()?.toLowerCase()}`
                  )
                }
                variant="contained"
                onClick={handleSaveFile}
                className="!capitalize h-10 w-32 rounded-lg"
              >
                Save
              </Button>
            </div>
          </div>
        </CustomBoxModal>
      )}
      <div className="mt-10 pb-10 flex justify-center space-x-10">
        <div className="mt-auto flex !cursor-pointer rounded-lg border-2 border-durotarFire px-3 py-1">
          <div onClick={handleSignatureIconClick}>
            <TextField
              className="border-green w-40 h-13.5 !text-black text-xs text-left !font-montserrat !cursor-pointer"
              InputLabelProps={{
                classes: {
                  root: "!text-sm !leading-5 !font-medium !text-platinumGranite !font-montserrat !pt-0.5 !pb-2 !cursor-pointer",
                  shrink: "!text-purpleComet !text-xs !cursor-pointer"
                }
              }}
              InputProps={{
                readOnly: true,
                value: uploadedFileName || "Upload",
                className: "!cursor-pointer"
              }}
              id="standard-basic"
              label="Signed MEF File (Optional)"
              variant="standard"
            />
            <FileUploadOutlinedIcon className="mt-4 cursor-pointer" />
          </div>
        </div>
        <Button
          variant="contained"
          classes={{ contained: "!rounded-lg !my-auto" }}
          onClick={() => {
            uploadMutation({ leadId, file: mefFile });
          }}
          className="!uppercase h-16 rounded-lg !text-sm"
        >
          Submit
        </Button>
      </div>
    </>
  );
}

export default memo(CustomerDeclarationDataEntry);
